import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { Logo, Heading, Paragraph } from 'elements';
import { SiteContainer, Flex, FlexItem } from 'core/layout';
import { Wind } from 'core/icons';
import tulkojumi from 'utils/tulkojumi';
import pathWithRewrite from 'utils/pathWithRewrite';
import {
  StyledWrapper,
  StyledHeader,
  FlexWrapper,
  StyledContentHeader,
  StyledBackgroundIcon,
  StyledNav,
  IconCol,
} from './styled';



const Kluda = ({ saites, teksti, homeURL }) => {
  return (
    <div>
      <Helmet>
        <title>
          {tulkojumi(teksti, 'mes_nevaram_atrast_lapu_kuru_mekleji')}
        </title>
        <meta name='robots' content='nofollow, noindex' />
      </Helmet>

      <StyledWrapper>
        <StyledHeader>
          <SiteContainer>
            <Link to={homeURL} rel="noopener" title={tulkojumi(teksti, 'liepaja_uz_sakumlapu')}>
              <Logo />
            </Link>
          </SiteContainer>
        </StyledHeader>

        <main>
          <SiteContainer>
            <FlexWrapper>
              <FlexItem>

                <StyledContentHeader>
                  <Heading>
                    {tulkojumi(teksti, 'kluda_404')}
                  </Heading>
                  <Paragraph size='large'>
                    {tulkojumi(teksti, 'mes_nevaram_atrast_lapu_kuru_mekleji')}
                  </Paragraph>
                </StyledContentHeader>

                {`${tulkojumi(teksti, 'noderigas_saites')}:`}
                <StyledNav>
                  <ul>
                    {
                      saites.map((item, i) => {
                        const rewrite = pathWithRewrite(item);
                        const external = rewrite.location.startsWith('http');
                        const LinkComponent = external ? 'a' : Link;
                        const linkProps = external ? {
                          href: rewrite.location,
                          target: rewrite.target,
                        } : {
                          to: item.path,
                        }
                        return (
                          <li key={i}>
                            <LinkComponent {...linkProps}>
                              {item.title}
                            </LinkComponent>
                          </li>
                        );
                      })
                    }
                  </ul>
                </StyledNav>
              </FlexItem>

              <StyledBackgroundIcon>
                <Wind />
              </StyledBackgroundIcon>
            </FlexWrapper>
          </SiteContainer>
        </main>
      </StyledWrapper>
    </div>
  )
}

export default Kluda



// WEBPACK FOOTER //
// ./src/pages/Kluda/Kluda.jsx